var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100.77 29.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #a6a6a6;\n      }\n\n      .cls-02 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.04,29.86H3.73c-2.09,0-3.73-1.64-3.73-3.73V3.73C0,1.64,1.64,0,3.73,0h93.3c2.09,0,3.73,1.64,3.73,3.73v22.39c0,2.09-1.64,3.73-3.73,3.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.04.6c1.72,0,3.13,1.42,3.13,3.13v22.39c0,1.72-1.42,3.13-3.13,3.13H3.73c-1.72,0-3.13-1.42-3.13-3.13V3.73C.6,2.02,2.02.6,3.73.6h93.3M97.04,0H3.73C1.64,0,0,1.72,0,3.73v22.39c0,2.09,1.64,3.73,3.73,3.73h93.3c2.09,0,3.73-1.64,3.73-3.73V3.73c0-2.02-1.64-3.73-3.73-3.73Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-02",
    d: "M21.2,14.84c-.02-2.32,1.9-3.44,1.98-3.5-1.09-1.58-2.77-1.8-3.36-1.82-1.41-.15-2.79.85-3.51.85s-1.84-.83-3.04-.81c-1.54.02-2.98.91-3.77,2.3-1.63,2.82-.41,6.97,1.15,9.24.78,1.12,1.69,2.36,2.89,2.32,1.17-.05,1.61-.75,3.02-.75s1.81.75,3.02.72c1.25-.02,2.04-1.12,2.8-2.25.9-1.28,1.26-2.54,1.28-2.61-.03,0-2.44-.93-2.46-3.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-02",
    d: "M18.9,8.03c.63-.79,1.06-1.86.94-2.94-.91.04-2.05.63-2.7,1.4-.58.68-1.1,1.79-.96,2.83,1.02.08,2.07-.51,2.73-1.29"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-02",
    d: "M37.46,20.76h-3.91l-.94,2.77h-1.66l3.7-10.26h1.72l3.7,10.26h-1.69l-.94-2.77ZM33.95,19.48h3.1l-1.53-4.5h-.04l-1.53,4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-02",
    d: "M48.08,19.8c0,2.32-1.24,3.82-3.12,3.82-1.07,0-1.91-.48-2.35-1.31h-.03v3.7h-1.54v-9.95h1.49v1.24h.03c.43-.8,1.34-1.32,2.38-1.32,1.9,0,3.15,1.5,3.15,3.82M46.5,19.8c0-1.51-.78-2.51-1.98-2.51s-1.96,1.02-1.96,2.51.79,2.52,1.96,2.52,1.98-.99,1.98-2.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-02",
    d: "M56.31,19.8c0,2.32-1.24,3.82-3.12,3.82-1.07,0-1.91-.48-2.35-1.31h-.03v3.7h-1.54v-9.95h1.49v1.24h.03c.43-.8,1.34-1.32,2.38-1.32,1.9,0,3.15,1.5,3.15,3.82M54.73,19.8c0-1.51-.78-2.51-1.98-2.51s-1.96,1.02-1.96,2.51.79,2.52,1.96,2.52,1.98-.99,1.98-2.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-02",
    d: "M61.75,20.68c.11,1.02,1.1,1.69,2.45,1.69s2.23-.67,2.23-1.59c0-.8-.56-1.27-1.89-1.6l-1.33-.32c-1.88-.46-2.76-1.34-2.76-2.77,0-1.77,1.54-2.98,3.73-2.98s3.65,1.22,3.7,2.98h-1.55c-.09-1.02-.94-1.64-2.17-1.64s-2.08.63-2.08,1.53c0,.73.54,1.15,1.86,1.48l1.13.28c2.1.5,2.98,1.34,2.98,2.84,0,1.92-1.53,3.12-3.96,3.12-2.27,0-3.81-1.17-3.91-3.03h1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-02",
    d: "M71.36,14.29v1.77h1.42v1.21h-1.42v4.12c0,.64.29.94.91.94.16,0,.4-.02.5-.03v1.21c-.17.04-.51.07-.85.07-1.51,0-2.1-.57-2.1-2.02v-4.29h-1.09v-1.21h1.09v-1.77h1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-02",
    d: "M73.6,19.8c0-2.35,1.39-3.83,3.55-3.83s3.55,1.48,3.55,3.83-1.37,3.83-3.55,3.83-3.55-1.47-3.55-3.83M79.13,19.8c0-1.61-.74-2.57-1.98-2.57s-1.98.96-1.98,2.57.74,2.57,1.98,2.57,1.98-.94,1.98-2.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-02",
    d: "M81.96,16.06h1.46v1.27h.04c.23-.85.92-1.35,1.8-1.35.22,0,.4.03.53.06v1.44c-.12-.05-.39-.09-.69-.09-.99,0-1.6.67-1.6,1.72v4.44h-1.54v-7.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-02",
    d: "M92.86,21.34c-.21,1.36-1.53,2.29-3.22,2.29-2.17,0-3.53-1.46-3.53-3.8s1.36-3.87,3.46-3.87,3.37,1.42,3.37,3.69v.53h-5.28v.09c0,1.28.8,2.12,2.01,2.12.85,0,1.52-.4,1.73-1.05h1.46ZM87.67,19.11h3.74c-.03-1.15-.77-1.9-1.83-1.9s-1.83.77-1.9,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-02",
    d: "M33.76,5.56c1.46,0,2.32.9,2.32,2.45s-.85,2.48-2.32,2.48h-1.78v-4.93h1.78ZM32.75,9.79h.93c1.03,0,1.62-.64,1.62-1.77s-.6-1.76-1.62-1.76h-.93v3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-02",
    d: "M36.94,8.63c0-1.2.67-1.93,1.75-1.93s1.75.73,1.75,1.93-.67,1.93-1.75,1.93-1.75-.73-1.75-1.93M39.7,8.63c0-.81-.36-1.28-1-1.28s-1,.47-1,1.28.36,1.28,1,1.28,1-.47,1-1.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-02",
    points: "45.11 10.49 44.35 10.49 43.58 7.75 43.53 7.75 42.76 10.49 42.01 10.49 40.98 6.77 41.72 6.77 42.39 9.61 42.45 9.61 43.21 6.77 43.92 6.77 44.68 9.61 44.74 9.61 45.4 6.77 46.14 6.77 45.11 10.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-02",
    d: "M47,6.77h.71v.59h.05c.18-.41.55-.66,1.11-.66.83,0,1.29.5,1.29,1.38v2.41h-.73v-2.22c0-.6-.26-.9-.8-.9s-.89.36-.89.94v2.17h-.73v-3.72Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-02",
    x: 51.33,
    y: 5.32,
    width: 0.73,
    height: 5.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-02",
    d: "M53.08,8.63c0-1.2.67-1.93,1.75-1.93s1.75.73,1.75,1.93-.67,1.93-1.75,1.93-1.75-.73-1.75-1.93M55.83,8.63c0-.81-.36-1.28-1-1.28s-1,.47-1,1.28.36,1.28,1,1.28,1-.47,1-1.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-02",
    d: "M57.36,9.44c0-.67.5-1.06,1.38-1.11l1.01-.06v-.32c0-.39-.26-.62-.76-.62-.41,0-.69.15-.77.41h-.71c.07-.64.68-1.05,1.52-1.05.93,0,1.46.46,1.46,1.25v2.54h-.71v-.52h-.06c-.22.37-.63.58-1.12.58-.72,0-1.24-.43-1.24-1.11M59.75,9.12v-.31l-.91.06c-.51.03-.74.21-.74.54s.29.53.69.53c.55,0,.96-.35.96-.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-02",
    d: "M61.45,8.63c0-1.18.6-1.92,1.54-1.92.51,0,.94.24,1.14.65h.05v-2.04h.73v5.17h-.7v-.59h-.06c-.22.41-.66.65-1.17.65-.94,0-1.54-.74-1.54-1.92M62.2,8.63c0,.79.37,1.26.99,1.26s1-.48,1-1.26-.39-1.26-1-1.26-.99.48-.99,1.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-02",
    d: "M67.96,8.63c0-1.2.67-1.93,1.75-1.93s1.75.73,1.75,1.93-.67,1.93-1.75,1.93-1.75-.73-1.75-1.93M70.71,8.63c0-.81-.36-1.28-1-1.28s-1,.47-1,1.28.36,1.28,1,1.28,1-.47,1-1.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-02",
    d: "M72.45,6.77h.71v.59h.05c.18-.41.55-.66,1.11-.66.83,0,1.29.5,1.29,1.38v2.41h-.73v-2.22c0-.6-.26-.9-.8-.9s-.89.36-.89.94v2.17h-.73v-3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-02",
    d: "M79.75,5.84v.94h.81v.62h-.81v1.91c0,.39.16.56.53.56.11,0,.18,0,.28-.02v.61c-.12.02-.26.04-.4.04-.82,0-1.14-.29-1.14-1v-2.1h-.59v-.62h.59v-.94h.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-02",
    d: "M81.56,5.32h.73v2.05h.06c.18-.42.57-.67,1.13-.67.79,0,1.28.5,1.28,1.39v2.4h-.73v-2.22c0-.59-.28-.9-.8-.9-.6,0-.94.38-.94.94v2.17h-.73v-5.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-02",
    d: "M89.04,9.48c-.17.67-.76,1.08-1.61,1.08-1.07,0-1.72-.73-1.72-1.92s.67-1.94,1.71-1.94,1.66.71,1.66,1.88v.26h-2.63v.04c.02.65.4,1.07.99,1.07.45,0,.75-.16.88-.45h.71ZM86.46,8.28h1.88c-.02-.58-.37-.96-.92-.96s-.92.38-.96.96"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleStore);
export default __webpack_public_path__ + "static/media/AppleStore.68a86deb781e4e621f91281114cab8eb.svg";
export { ForwardRef as ReactComponent };